import React from 'react'

class TaskOptions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      taskOptions: '',
      wrapperRef: ''
    };
    this.wrapperRef = '';
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({taskOptions: ''});
    }
  }

  toggleOptions() {
    this.state.taskOptions === 'shown' ? this.setState({taskOptions: ''}) : this.setState({taskOptions: 'shown'})
  }

  handleClick() {
    $.ajax({
      url: `/schedules/${this.props.data.id}/toggle_visibility/`,
      method: 'PUT',
      dataType: 'JSON',
      data: {checked: !this.props.data.visible},
      success: res => {
        return this.props.onHelpfulCheck(res);
      }
    });
  }

    handleRescheduleClick() {
      return this.props.handleCustomTaskClick();
    }

    handleDelete() {
      $.ajax({
        type: 'DELETE',
        data: { date: this.props.data.date, checked: this.props.data.check_status },
        url: `/timeline_items/${this.props.data.timeline_id}`,
        success: response => {
          if (response.id) {
            this.props.handleCustomTaskDelete(response);
            toastr.success('Task deleted successfully');
          } else {
            toastr.error('Task not deleted');
          }
        }
      });
    }

    _option(icon, text, action){
      return (
        <tr onClick={action.bind(this)}>
          <th>
            <i className={`fa ${icon}`}/>
          </th>
          <th> {text}</th>
        </tr>
      );
    }

    renderTBody() {
      if (this.props.data.custom_task){
        return(
          <tbody>
            { this._option('fa-pencil-square-o', 'Edit', this.handleRescheduleClick) }
            { this._option('fa-times', 'Delete task', this.handleDelete) }
            {  this._option('fa-eye', 'Hide task', this.handleClick) }
          </tbody>
        )
      } else {
        return (
          <tbody>
            { !this.props.data.event_type == 'Essential' && this._option('fa-history', 'Reschedule', this.handleRescheduleClick) }
            { !this.props.disabledTaskEmailNotifications && this._option('fa-clock-o', 'Add Reminder', this.handleRescheduleClick) }
            { this._option('fa-eye', 'Hide task', this.handleClick) }
          </tbody>
        )
      }
    }

    render() {
      let toggleOptionContainer = null;
      let toggleTaskContent = null;

      if(this.state.taskOptions == 'shown') {
        toggleOptionContainer =  (<div className='toggle-options' ref={this.setWrapperRef.bind(this)}>
                    <table className='task-options-tb'>
                      { this.renderTBody() }
                    </table>
                  </div>);
      }

      if(!this.props.isLeavePlanPartner){
        if (this.props.data.visible) {
          toggleTaskContent = (<div onClick={this.toggleOptions.bind(this)}>
                      <i className='fa fa-ellipsis-h fa-2x'/>
                      {toggleOptionContainer}
                    </div>);
        } else {
          toggleTaskContent = (
          <i title="Unhide task" className='fa fa-lg fa-eye-slash' onClick={this.handleClick.bind(this)}></i>
          )
        }
      }
      return (
        <div className='toggle-task'>
          {toggleTaskContent}
        </div>
      )
    }
}

export default TaskOptions
